var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-game group-game_player"},[_c('JoinMessage',{attrs:{"message":"Drum roll please..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }